export default __webpack_public_path__ + "static/media/UnsaveProspectBlue.5f9bf22a.svg";